import { commandPalette } from '@bp-files/ui';

/**
 * The cursor shown over the page while the signature tool is armed (FIL-8c).
 *
 * A small white, rounded square with the same pen-nib glyph the sign button
 * shows before a signature is stored — so the cursor reads as "the sign
 * button, about to land" rather than a generic crosshair.
 *
 * **Colours are read from `commandPalette` at import time, not `token()`.**
 * A `cursor: url(...)` image is an independent resource — it does not sit in
 * this document's box tree, so it cannot resolve `var(--bp-ink)` the way an
 * inline `<svg>` or a canvas 2D context (`StoredSignature.tsx`) can. Pulling
 * the literal values from the palette object keeps this driven by the one
 * source of truth without writing a raw hex string in this file, which
 * `eslint.design-system.mjs`'s `no-restricted-syntax` forbids outside
 * `tokens.ts`.
 */

const SIZE = 32;
const GLYPH = 'M12 19h8M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z';

const svg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="${String(SIZE)}" height="${String(SIZE)}" viewBox="0 0 ${String(SIZE)} ${String(SIZE)}">
    <rect x="2" y="2" width="28" height="28" rx="6" fill="${commandPalette['bp-on-accent']}" stroke="${commandPalette['bp-border']}" stroke-width="1.5" />
    <g transform="translate(7 7) scale(0.75)" fill="none" stroke="${commandPalette['bp-ink']}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="${GLYPH}" />
    </g>
  </svg>
`
  .trim()
  .replace(/\s+/g, ' ');

/**
 * A hotspot near the nib's tip, so the pointer lands where the pen would —
 * `crosshair` is the fallback for a browser that ignores the image
 * (`SignaturePad.tsx`'s own drawing cursor uses the same fallback keyword).
 */
export const SIGNATURE_CURSOR = `url("data:image/svg+xml,${encodeURIComponent(svg)}") 12 21, crosshair`;
